import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// import styles from "./FullscreenLayout.scss";
import {
  Button,
  DrawerBody,
  DrawerHeader,
  DrawerHeaderTitle,
  InlineDrawer,
  makeStyles,
  OverlayDrawer
} from "@fluentui/react-components";
import { FormattedMessage, useIntl } from "react-intl";
import { Dismiss24Regular } from "@fluentui/react-icons";

const useStyles = makeStyles({
  sidebarLayout: {
    width: "100%",
    "@media (min-width: 1200px)": {
      width: "500px"
    }
    // zIndex: 99999
  },
  header: {
    backgroundColor: "var(--primaryColorBackground)"
  }
});

export function FullscreenLayout({
  className,
  headerLeft,
  headerCenter,
  headerRight,
  open,
  setOpen,
  contentClassName,
  children,
  loading
}) {
  const intl = useIntl();

  const styles = useStyles();

  return (
    <OverlayDrawer
      className={styles.sidebarLayout}
      position="end"
      open={open}
      modalType="non-modal"
      // onOpenChange={(_, data) => setOpen(data.open)}
    >
      <DrawerHeader className={styles.header}>
        <DrawerHeaderTitle
          action={
            <Button
              appearance="subtle"
              aria-label={intl.formatMessage({ id: "room-settings-sidebar.close-button", defaultMessage: "Close" })}
              icon={<Dismiss24Regular />}
              onClick={() => setOpen(false)}
              disabled={loading}
            />
          }
        >
          {headerCenter}
        </DrawerHeaderTitle>
      </DrawerHeader>
      <DrawerBody>
        <div className={classNames(styles.content, contentClassName)}>{children}</div>
      </DrawerBody>
    </OverlayDrawer>
  );
}

FullscreenLayout.propTypes = {
  className: PropTypes.string,
  headerLeft: PropTypes.node,
  headerCenter: PropTypes.node,
  headerRight: PropTypes.node,
  contentClassName: PropTypes.string,
  children: PropTypes.node,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  loading: PropTypes.bool
};
